export type CompositeElementType = 'text' | 'pictures' | 'documents' | 'checklist' | 'location' | 'time';

export class CompositeElementTypes {
    public TEXT: CompositeElementType = 'text';
    public PICTURES: CompositeElementType = 'pictures';
    public DOCUMENTS: CompositeElementType = 'documents';
    public CHECKLIST: CompositeElementType = 'checklist';
    public LOCATION: CompositeElementType = 'location';
    public TIME: CompositeElementType = 'time';
}

export class PipCompositeElementTypes {
    public static TEXT: CompositeElementType = 'text';
    public static PICTURES: CompositeElementType = 'pictures';
    public static DOCUMENTS: CompositeElementType = 'documents';
    public static CHECKLIST: CompositeElementType = 'checklist';
    public static LOCATION: CompositeElementType = 'location';
    public static TIME: CompositeElementType = 'time';
}
